import { render, staticRenderFns } from "./4MolecularDesign.vue?vue&type=template&id=06780443&"
import script from "./4MolecularDesign.vue?vue&type=script&lang=js&"
export * from "./4MolecularDesign.vue?vue&type=script&lang=js&"
import style0 from "./4MolecularDesign.vue?vue&type=style&index=0&id=06780443&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports